import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';
import { AbstractState } from './migrator-utils';

export function mergeState(
  destination: AbstractState,
  sources: AbstractState,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any {
  return mergeWith(destination, sources, customizer);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function customizer(objValue: unknown, srcValue: unknown): any {
  // NOSONAR
  if (isArray(objValue) && srcValue !== undefined) {
    return srcValue;
  }
}
